import { Component, Input, OnInit } from '@angular/core';
import { ProducSpecsDoubleColumn, ProducSpecsDoubleColumnNormalized } from '../../core/product-specifications.model';
import { ProductSpecificationsService } from '../../core/product-specifications.service';

@Component({
  selector: 'generic-table-double-attrs',
  templateUrl: './generic-table-double-attrs.component.html',
  styleUrl: './generic-table-double-attrs.component.scss',
  standalone: false,
})
export class GenericTableDoubleAttrsComponent implements OnInit {
  @Input() table!: any;
  @Input() _table?: ProducSpecsDoubleColumnNormalized;

  constructor(private productSpecificationsService: ProductSpecificationsService) {}

  ngOnInit(): void {
    if (this.table) {
      this._table = this.normalizeTabDoubleCollumn(this.table);
    }
  }

  normalizeTabDoubleCollumn(tab: ProducSpecsDoubleColumn): ProducSpecsDoubleColumnNormalized {
    return this.productSpecificationsService.normalizeTabDoubleCollumn(tab);
  }
}
